gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
document.addEventListener("DOMContentLoaded", () => {


    const scrollerSVG = document.querySelector('.mag-hero__scroller svg');
    const scrollerLabel = document.querySelector('.mag-hero__scroller-label');
    const chipsetBack = document.querySelector('.mag-chipset__backimg');
    const chipsetLight = document.querySelector('.mag-chipset__chipset-light');
    const chipsetDark = document.querySelector('.mag-chipset__chipset-dark');
    const heroContent = document.querySelector('.mag-hero__content');
    const chipsetBackImgOverlay = document.querySelector('.mag-chipset__backimg-overlay');
    const svgTitles = document.querySelectorAll('.mag-chipset__heading');
    const allCards = document.querySelectorAll('.mag-chipset__card');
    const storyOverlay = document.querySelector(`.mag-chipset__stories-overlay`);

    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    };

    // Function to hide a card with GSAP animation
    function hideCard(card) {
        gsap.to(card, {
            opacity: 0,
            scale: 0.8,
            zIndex: 100,
            duration: 0.5,
            pointerEvents:'none',
            ease: 'power2.out',
        });
    }
    function hideOverlay(overlay) {
        gsap.to(overlay, {
            opacity: 0,
            zIndex: 1,
            duration: 0.5,
            ease: 'power2.out',
        });
    }

    // Add event listeners for click, mouseenter, and mouseleave
    svgTitles.forEach(title => {

        const svgId = title.getAttribute('data-svg');
        const associatedCard = document.querySelector(`.mag-chipset__card[data-svg="${svgId}"]`);
        const storyOverlay = document.querySelector(`.mag-chipset__stories-overlay`);

        title.addEventListener('click', () => {
            allCards.forEach(card => hideCard(card));
        
            if (associatedCard) {
                // Add overflow: hidden to body and html
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
        
                gsap.to(storyOverlay, {
                    opacity: 1,
                    duration: 0.5,
                    zIndex: 1000,
                    ease: 'power2.out',
                });               
                gsap.to(associatedCard, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.5,
                    zIndex: 500,
                    pointerEvents:'all',
                    ease: 'power2.out',
                });
            }
        });
    });

    document.querySelectorAll('.mag-chipset__card-closer').forEach(closer => {
        closer.addEventListener('click', () => {
            const storyOverlay = document.querySelector(`.mag-chipset__stories-overlay`);
            hideOverlay(storyOverlay);
            const parentCard = closer.closest('.mag-chipset__card');
            document.body.style.overflow = 'hidden auto';
            document.documentElement.style.overflow = '';
            if (parentCard) {
                hideCard(parentCard);
            }
        });
    });



 

    //////// Scrolling chipset animation /////////

    let mm = gsap.matchMedia();

    //Desktop Behaviour
    mm.add("(min-width: 1024px)", () => {

        ScrollTrigger.create({
            trigger: ".mag-chipset",
            start: "top-=10 bottom",
            end: "bottom+=1000 top",
            pin: ".mag-hero",
            pinSpacing: false,
            scrub: true,
            marker: true
        });

        gsap.set(".mag-chipset__path--desk path", { drawSVG: "0%" });
        gsap.set(".mag-chipset__path--desk .circle-svg", { opacity: 0 });

        // Animation when .mag-chipset__chipset enters viewport
        gsap.timeline({
            scrollTrigger: {
                trigger: ".mag-chipset__chipset",
                start: "top bottom",
                end: "center center",
                scrub: true,
            }
        })
            .to(heroContent, {
                y: -400,
                opacity: 0,
                ease: "power1.out",
            })
            .to(".mag-hero__intro", {
                y: -250,
                opacity: 0,
                ease: "power1.out",
            }, "<");

        // Chipset scroll-triggered animations
        gsap.timeline({
            scrollTrigger: {
                trigger: ".mag-chipset",
                start: "top top",
                end: "bottom+=3000 top",
                scrub: 2,
                pin: true,
            }
        })
            .to([scrollerSVG, scrollerLabel], {
                opacity: 0,
                ease: "power1.out"
            }, '<')
            .to(".mag-chipset__path--desk path", {
                drawSVG: "100%",
                duration: 2,
                ease: "none",
            })
            .to(".mag-chipset__heading", {
                opacity: 1,
                duration: 2,
                stagger: 1.5,
                ease: "power1.out"
            })
            .to(".mag-chipset__path--desk .circle-svg", {
                opacity: 1,
                duration: 2,
                stagger: 1.5,
                ease: "power1.out",
                onReverseComplete: () => {
                    hideCard(allCards);
                    hideOverlay(storyOverlay);
                }
            }, '<')
            .to(".mag-chipset__heading", {
                opacity: 0,
                duration: 1,
                ease: "power1.out",
                onComplete: () => {
                    hideCard(allCards);
                    hideOverlay(storyOverlay);
                }
            })
            .to(".mag-chipset__path--desk .circle-svg", {
                opacity: 0,
                duration: 1,
                ease: "power1.out",
                onComplete: () => chipsetBack.classList.add("show")
            }, '<')
            .to(chipsetBack, {
                opacity: 1,
                duration: 0.5,
                ease: "none"
            })
            .to(chipsetBackImgOverlay, {
                y: '-100%',
                ease: "none",
                duration: 3,
            })
            .to(chipsetLight, {
                opacity: 1,
                duration: 3,
                ease: "none"
            }, '<')
            .to(".mag-chipset__path--desk path", {
                drawSVG: "0",
                duration: 1,
                ease: "none"
            })
            .to(chipsetDark, {
                opacity: 0,
                duration: 0.3,
                ease: "none"
            }, '<');

    });

    // Responsive behaviour
    mm.add("(max-width: 1024px)", () => {

        // Pin the .mag-hero section until .mag-chipset overlaps
        ScrollTrigger.create({
            trigger: ".mag-chipset",
            start: "top-=10 bottom",
            end: "bottom+=1000 top",
            pin: ".mag-hero",
            pinSpacing: false,
            scrub: true,
            marker: true
        });

        gsap.set(".mag-chipset__path--mob path", { drawSVG: "0%" });
        gsap.set(".mag-chipset__path--mob .circle-svg", { opacity: 0 });

        // Animation when .mag-chipset__chipset enters viewport
        gsap.timeline({
            scrollTrigger: {
                trigger: ".mag-chipset__chipset",
                start: "top bottom",
                end: "center center",
                scrub: true,
            }
        })
            .to(heroContent, {
                y: -400,
                opacity: 0,
                ease: "power1.out",
            })
            .to(".mag-hero__intro", {
                y: -250,
                opacity: 0,
                ease: "power1.out",
            }, "<");

        // Chipset scroll-triggered animations
        gsap.timeline({
            scrollTrigger: {
                trigger: ".mag-chipset",
                start: "top top",
                end: "bottom+=2000 top",
                scrub: 2,
                pin: true,
            }
        })
            .to([scrollerSVG, scrollerLabel], {
                opacity: 0,
                ease: "power1.out"
            }, '<')
            .to(".mag-chipset__path--mob path", {
                drawSVG: "100%",
                duration: 2,
                ease: "none"
            })
            .to(".mag-chipset__heading", {
                opacity: 1,
                duration: 2,
                stagger: 1.5,
                ease: "power1.out"
            })
            .to(".mag-chipset__path--mob .circle-svg", {
                opacity: 1,
                duration: 1.5,
                ease: "power1.out"
            }, '<')
            .to(".mag-chipset__heading", {
                opacity: 0,
                duration: 1,
                ease: "power1.out",
                onComplete: () => chipsetBack.classList.add("show")
            })
            .to(".mag-chipset__path--mob .circle-svg", {
                opacity: 0,
                duration: 1,
                ease: "power1.out",
                onComplete: () => chipsetBack.classList.add("show")
            }, '<')
            .to(".mag-chipset__path--mob path", {
                drawSVG: "0",
                duration: 1,
                ease: "none"
            }, '<')
            .to(chipsetBack, {
                opacity: 1,
                duration: 0.5,
                ease: "none"
            })
            .to(chipsetBackImgOverlay, {
                y: '-100%',
                ease: "none",
                duration: 2,
            })
            .to(chipsetLight, {
                opacity: 1,
                duration: 1.5,
                ease: "none"
            }, '<')

            .to(chipsetDark, {
                opacity: 0,
                duration: 0.3,
                ease: "none"
            });

    });

    function positionHeadings() {
        // Determine if we are at max-width 1024px or larger
        const isMobileView = window.innerWidth <= 1024;
      
        // Get all the heading elements and container
        const headings = document.querySelectorAll(".mag-chipset__heading");
        const container = document.querySelector(".mag-chipset__headings");
        const containerRect = container.getBoundingClientRect();
      
        // Iterate over each heading element
        headings.forEach((heading) => {
          const svgId = heading.dataset.svg;
      
          // Select the appropriate circle based on screen width
          const pathType = isMobileView ? "mob" : "desk";
          const circleElement = document.querySelector(`.mag-chipset__path--${pathType} circle[data-svg="${svgId}"]`);
      
          if (circleElement) {
            // Get the position of the circle relative to the container
            const circleRect = circleElement.getBoundingClientRect();
      
            // Calculate the position relative to the container
            let offsetX = circleRect.left - containerRect.left;
            let offsetY = circleRect.top - containerRect.top;
      
            // Adjust positioning for specific svgIds
            if (["svg-1", "svg-2"].includes(svgId)) {
              offsetX += circleRect.width - heading.clientWidth;
              offsetY += circleRect.height - heading.clientHeight;
            } else if (["svg-3", "svg-4", "svg-5"].includes(svgId)) {
              offsetY += circleRect.height - heading.clientHeight;
            }
      
            // Position the heading
            Object.assign(heading.style, {
              position: "absolute",
              left: `${offsetX}px`,
              top: `${offsetY}px`,
            });
          }
        });
      }
    
      // Initial positioning of headings
      positionHeadings();
    
      // Recalculate position on window resize
      window.addEventListener("resize", positionHeadings);

});